import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/blog-detail.css';
import blogsData from '../data/blogs.json';

function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogsData.blogs.find(b => b.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!blog) {
    navigate('/blog');
    return null;
  }

  const renderContent = (content) => {
    return content.map((block, index) => {
      switch (block.type) {
        case 'paragraph':
          return (
            <div key={index} className="blog-paragraph-block">
              {block.image && (
                <img src={block.image} alt={block.text} className="blog-content-image" />
              )}
              <p className="blog-paragraph">{block.text}</p>
            </div>
          );
        case 'heading':
          return (
            <div key={index} className="blog-heading-block">
              {block.image && (
                <img src={block.image} alt={block.text} className="blog-content-image" />
              )}
              <h2 className="blog-heading">{block.text}</h2>
            </div>
          );
        case 'list':
          return (
            <ul key={index} className="blog-list">
              {block.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <div className="blog-detail-page">
      <article className="blog-article">
        <div className="blog-header">
          <div className="container">
            <div className="blog-meta">
              <span className="blog-category">{blog.category}</span>
              <span className="blog-date">{new Date(blog.date).toLocaleDateString()}</span>
              <span className="blog-read-time">{blog.readTime}</span>
            </div>
            <h1 className="blog-title">{blog.title}</h1>
            <div className="blog-author">
              <span>By {blog.author}</span>
            </div>
          </div>
        </div>

        <div className="blog-featured-image">
          <img src={blog.featuredImage} alt={blog.title} />
        </div>

        <div className="blog-content container">
          {renderContent(blog.content)}
          
          <div className="blog-tags">
            {blog.tags.map((tag, index) => (
              <span key={index} className="tag">#{tag}</span>
            ))}
          </div>
        </div>
      </article>
    </div>
  );
}

export default BlogDetail;